export default {
    "apiUrl": 'https://bxb-dash-api.cactusminds.com/admin/',
    "mobileApiUrl": 'https://bxb-dash-api.cactusminds.com/',
    "mediaUrl": 'https://bxb-dash-api.cactusminds.com',

    // "apiUrl": 'https://football-api.cactusminds.com/admin/',
    // "mobileApiUrl": 'https://football-api.cactusminds.com/',
    // "mediaUrl": 'https://football-api.cactusminds.com',

    // "apiUrl": 'http://localhost:8000/admin/',
    // "mobileApiUrl": 'http://localhost:8000/',
    // "mediaUrl": 'http://localhost:8000',
}